<div fxLayout="row wrap">
    <div fxFlex.gt-sm="100%" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <p>{{'soon' | translate}} ;-)</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
